import { Component, Input, OnChanges } from '@angular/core';
import { EvtAlertService } from '@entities/evt-alert/evt-alert.service';
import { ModalService } from '@shared/services/modal.service';
import { NavigationService } from '@core/services/navigation.service';
import { EvtAgentReply, EvtAlertMessage } from '@entities/evt-alert/evt-alert.adapter';
import { EvtAlertStoreEntity } from '@entities/evt-alert/evt-alert.reducer';
import { PeoplePageRepresentation } from '@core/constants/pages';
import { Nullable } from '@shared/utils/type.utils';

@Component({
    selector: 'nwx-next-step-evt-alerts',
    templateUrl: './next-step-evt-alerts.component.html',
    styleUrl: './next-step-evt-alerts.component.scss',
    standalone: false
})
export class NextStepEvtAlertsComponent implements OnChanges {
  @Input() evtAlerts: EvtAlertStoreEntity[] = [];
  @Input() savedAgentReply: Nullable<EvtAgentReply> = null;

  autoAlert?: EvtAlertStoreEntity
  replyAlert?: EvtAlertMessage;
  hasReplyConfirmed?: boolean;

  constructor(
    private evtAlertService: EvtAlertService,
    private navigationService: NavigationService,
    private modalService: ModalService,
  ) {}

  ngOnChanges(): void {
    this.autoAlert = this.evtAlerts
      .find((alert) => alert.productType === 'PersonalAuto');
    this.replyAlert = this.autoAlert?.response
      ?.find((alert) => this.alertRequiresReply(alert.message));
    this.hasReplyConfirmed = !!this.savedAgentReply?.agentReply;
  }

  navigateToAddDriver(): void {
    this.navigationService.navigateToPage(PeoplePageRepresentation);
  }

  openReplyModal(): void {
    if (this.autoAlert && this.replyAlert) {
      this.modalService.evtAlertReplyModal(this.autoAlert.productType, this.autoAlert.quoteId, this.replyAlert);
    }
  }

  alertRequiresReply(message: string): boolean {
    return this.evtAlertService.alertRequiresReply(message);
  }
}
